import axios from "axios";
import {
  SERVICE_LIST_REQUEST,
  SERVICE_LIST_SUCCESS,
  SERVICE_LIST_FAIL,
  POST_SERVICE_REQUEST,
  POST_SERVICE_SUCCESS,
  POST_SERVICE_FAIL,
  UPDATE_SERVICE_REQUEST,
  UPDATE_SERVICE_SUCCESS,
  UPDATE_SERVICE_FAIL,
  DELETE_SERVICE_REQUEST,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAIL,
} from "constants/serviceConstants";
import { REACT_APP_API_URL } from "constants/apiConstants";
import ServicesService from "services/services-service";

export const getServiceList = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: SERVICE_LIST_REQUEST,
    });

    const res = await ServicesService.getServices();
    console.log("🚀 ~ file: serviceActions.js:26 ~ getServiceList ~ res:", res);

    dispatch({
      type: SERVICE_LIST_SUCCESS,
      payload: res.foundServices,
    });
  } catch (error) {
    dispatch({
      type: SERVICE_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const postService = (service) => async (dispatch, getState) => {
  try {
    dispatch({
      type: POST_SERVICE_REQUEST,
    });

    const res = await ServicesService.createServices(service);
    console.log("🚀 ~ file: serviceActions.js:53 ~ postService ~ res:", res);

    dispatch(getServiceList());

    dispatch({
      type: POST_SERVICE_SUCCESS,
      payload: res,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: serviceActions.js:60 ~ postService ~ error:",
      error
    );
    dispatch({
      type: POST_SERVICE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const serviceUpdating =
  (serviceId, service) => async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_SERVICE_REQUEST,
      });

      const res = await ServicesService.editServices(serviceId, service);
      console.log("🚀 ~ file: serviceActions.js:78 ~ res:", res);

      dispatch(getServiceList());

      dispatch({
        type: UPDATE_SERVICE_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log("🚀 ~ file: serviceActions.js:86 ~ error:", error);
      dispatch({
        type: UPDATE_SERVICE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const serviceDeleting = (serviceId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DELETE_SERVICE_REQUEST,
    });

    // const { adminLogin: { adminInfo } } = getState();

    // const config = {
    //   headers: {
    //     Authorization: adminInfo.token
    //   }
    // }

    const res = await axios.delete(
      `${REACT_APP_API_URL}/admin/services/${serviceId}`
    );

    dispatch({
      type: DELETE_SERVICE_SUCCESS,
      payload: res,
    });
  } catch (error) {
    dispatch({
      type: DELETE_SERVICE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};
